import competitionBuyIndex from "@/views/competitionBuy/index.vue"
import competitionBuyDetail from "@/views/competitionBuy/detail.vue"
import competitionBuyLogin from "@/views/competitionBuy/login.vue"
import competitionBuyMy from "@/views/competitionBuy/my.vue"
import projectDetails from "@/views/competitionBuy/projectDetailsJm.vue"

const competitionBuy = [{
    path: 'competitionBuy',
    name: 'competitionBuy',
    component: competitionBuyIndex,
    meta: { activeMenuIndex: 3 },
}, {
    path: 'competitionBuyDetail',
    name: 'competitionBuyDetail',
    component: competitionBuyDetail,
    meta: { activeMenuIndex: 3 },
},{
    path: 'competitionBuyLogin',
    name: 'competitionBuyLogin',
    component: competitionBuyLogin,
    meta: { activeMenuIndex: 3 },
},{
    path: 'competitionBuyMy',
    name: 'competitionBuyMy',
    component: competitionBuyMy,
    meta: { activeMenuIndex: 3 },
},
{
    path: 'projectDetailsJm',
    name: 'projectDetailsJm',
    component: projectDetails,
    meta: { activeMenuIndex: 3 },
}
 ]
export default competitionBuy


// WEBPACK FOOTER //
// ./src/router/competitionBuy/index.js